module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0081.af85236e.jpg";